import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Popover, OverlayTrigger } from "react-bootstrap";
import styled from "styled-components";

import { AmountTD, CurrencyTD, Td } from "commons";
import { convertToMoney } from "commons/src/Money";

export class FeesTD extends PureComponent {
    amount = () => {
        if (this.props.fees !== null && this.props.fees.length !== 0) {
            return (
                this.props.fees.reduce((a, b) => {
                    return b.dtrnDeductionAmount === null ? a : a + b.dtrnDeductionAmount;
                }, 0) * -1
            );
        }
        return 0;
    };

    tooltipText = () => {
        return this.props.fees.map((fee, index) => (
            <div key={index}>
                {fee.xptpShortDescription + ": " + convertToMoney(fee.dtrnDeductionAmount)}
                {fee < this.props.fees.length - 1 ? <br /> : ""}
            </div>
        ));
    };

    render() {
        if (this.props.fees === null || this.props.fees.length === 0 || this.props.expandedState) {
            return <Td />;
        } else if (this.props.amountInFeesColumn) {
            return <CurrencyTD amount={this.props.fees[0]} />;
        } else {
            const tooltip = (
                <Popover id="popover">
                    <Popover.Content>{this.tooltipText()}</Popover.Content>
                </Popover>
            );
            const amount = this.amount(this.props.fees);
            return (
                <AmountTD amount={amount}>
                    <OverlayTrigger
                        overlay={tooltip}
                        placement="top"
                        delayShow={300}
                        delayHide={150}
                    >
                        <Hint>{convertToMoney(amount)}</Hint>
                    </OverlayTrigger>
                </AmountTD>
            );
        }
    }
}

export const Hint = styled.span`
    border-bottom: 1px dotted #999;

    @media print {
        border-bottom: none;
    }
`;

FeesTD.propTypes = {
    fees: PropTypes.array,
    amountInFeesColumn: PropTypes.bool,
    expandedState: PropTypes.bool
};
